(function (module) {
    'use strict';

    function AddFilesCtrl($q, $http, envService, Store, Upload) {

        this.$onInit = () => {
            this.uploading = [];
            this.dropFilesBox = true;
            this.disabledWhenUploading = false;

            this.account = Store.getCurrentAccount();
            this.subAccountId = Store.getCurrentSubAccountId();
            this.SLS_URI = envService.read('SLS_URI');
        };

        this.uploadMore = () => {
            this.uploading = [];
            this.dropFilesBox = true;
        };

        this.clickHere = () => {
            this.dropFilesBox = false;
        };

        this.getFileInfo = (file) => {
            const deferred = $q.defer();

            const imageOnLoad = () => {
                const image = new Image;
                image.onload = () => {
                    const { width, height } = image;
                    deferred.resolve({ width, height });
                };
                image.onerror = error => {
                    return deferred.reject(error);
                };
                image.src = URL.createObjectURL(file);
            };

            const videoOnLoad = () => {
                const video = document.createElement('video');
                video.preload = 'metadata';
                video.addEventListener('loadedmetadata', function () {
                    URL.revokeObjectURL(video.src);
                    deferred.resolve({
                        height: this.videoHeight,
                        width: this.videoWidth,
                        duration: this.duration,
                    });
                });

                video.addEventListener('error', function (event) {
                    console.error('Video upload error', video.error);
                    deferred.reject(video.error);
                });

                video.src = URL.createObjectURL(file);
            };

            if (file.type.match(/video/)) {
                videoOnLoad();
            } else {
                imageOnLoad();
            }

            return deferred.promise;
        };

        this.back = () => {
            $state.go('root.files');
        };

        this.getUploadProgressPercentage = () => {
            this.disabledWhenUploading = true;
            const total = this.uploading.length * 100;
            const progress = _.chain(this.uploading)
                .filter((file) => {
                    return file.info.state !== 'uploading error';
                })
                .sumBy('info.progress')
                .value();

            const completedPercentage = Math.floor((progress || 0) * 100 / total);
            if (completedPercentage === 100) {
                this.disabledWhenUploading = false;
            }
            return completedPercentage;
        };

        this.getUploadUrl = (file) => {
            return this
                .getFileInfo(file)
                .then(({ width, height, duration }) => {

                    // add info
                    file.width = width;
                    file.height = height;

                    const data = {
                        height: file.height,
                        width: file.width,
                        fileName: encodeURI(file.name),
                        fileType: file.type,
                        fileCache: 'public, max-age=31536000',
                        accountId: this.account.id,
                    };

                    if (this.subAccountId) {
                        _.set(data, 'subAccountId', this.subAccountId);
                    }

                    if (duration && duration !== Infinity) {
                        data.duration = duration;
                    }

                    return $http({
                        method: 'POST',
                        url: `${this.SLS_URI}/files/upload`,
                        data,
                    });
                })
                .catch((err) => {
                    this.uploading[file.index].info = _.extend({
                        index: file.index,
                        id: '----',
                        fileName: file.name,
                        fileType: file.type,
                    }, {
                        state: 'uploading error',
                        progress: 100,
                    });

                    throw(err);
                });
        };

        this.progress = ({ index, id, fileName, fileType }, event) => {
            const progress = parseInt(93.0 * event.loaded / event.total);
            this.uploading[index].info = _.extend({ index, id, fileName, fileType }, { progress, state: 'uploading' });
        };

        this.success = ({ index, id, fileName, fileType, accountId }, response) => {
            this.createThumbnail(accountId, id, fileType)
                .then(res => {
                    const file = this.uploading[index];
                    const fileType = _.get(file, 'info.fileType', '');
                    if (fileType.match(/video/)) {
                        file.videoPreview = _.get(res, 'data.thumbnail');
                    }
                })
                .then(() => {
                    this.uploading[index].info = _.extend({ index, id, fileName, fileType }, {
                        state: 'completed',
                        flag: 'success',
                        progress: 100,
                    });
                    this.filesExist = true;
                    this.disabledWhenUploading = false;
                });
        };

        this.error = ({ index, id, fileName, fileType }, error) => {
            this.uploading[index].info = _.extend({ index, id, fileName, fileType }, {
                state: 'uploading error',
                progress: 100,
            });
        };

        this.enter = (event) => {
            console.log('event', event);
        };

        this.uploadFile = (file, next) => {
            this
                .getUploadUrl(file)
                .then(({ data }) => {
                    const url = _.get(data, 'url');
                    if (!url) {
                        console.error('Missing upload url', { response });
                    }
                    return data;
                })
                .then(({ url, accountId, subAccountId, id, fileName, fileType, fileCache }) => {
                    const headers = {
                        'Content-Type': fileType ? fileType : 'application/octet-stream',
                        'Cache-Control': fileCache,
                        'x-amz-meta-accountId': accountId,
                        'x-amz-meta-fileName': encodeURI(fileName),
                        'x-amz-meta-id': id,
                        'x-amz-meta-height': file.height,
                        'x-amz-meta-width': file.width,
                    };

                    if (subAccountId) {
                        _.set(headers, 'x-amz-meta-subAccountId', subAccountId);
                    }

                    if (file.duration) {
                        headers['x-amz-meta-duration'] = file.duration;
                    }

                    return Upload
                        .http({
                            url,
                            method: 'PUT',
                            headers,
                            data: file,
                        })

                        // progress hooks
                        .then(
                            this.success.bind(this, { index: file.index, id, fileName, fileType, accountId }),
                            this.error.bind(this, { index: file.index, id, fileName, fileType }),
                            this.progress.bind(this, { index: file.index, id, fileName, fileType }),
                        );

                })
                .then(next)
                .catch(next);

        };

        // for multiple files:
        this.uploadFiles = (files) => {
            const SUPPORTED_FILES = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'video/mp4', 'video/webm'];

            // remove files that are not supported
            const FILES = files.filter((file) => {
                if (SUPPORTED_FILES.indexOf(file.type) > -1) {
                    return true;
                } else {
                    return false;
                }
            });

            if (!FILES || !FILES.length) return;
            this.dropFilesBox = false;

            // mark as uploading
            FILES.forEach((file, index) => {
                file.index = index;
                this.uploading[index] = { index, info: { state: 'preparing', progress: 0 }, preview: file };
            });

            // upload X at a time
            const limit = 5;
            async.eachLimit(FILES, limit, this.uploadFile, (error) => {
                if (error) {
                    console.error('Upload file error', error);
                }
            });
        };

        this.createThumbnail = (accountId, id, fileType) => {
            const key = `account-${accountId}/${id}`;
            const url = fileType.match(/video/)
                ? `${this.SLS_URI}/files/video-thumbnail`
                : `${this.SLS_URI}/files/thumbnail`;

            return $http({
                method: 'POST',
                url,
                data: {
                    key,
                },

            }).catch(error => {
                console.log('error', error);
            });
        };
    }

    module
        .config(function ($stateProvider, $translatePartialLoaderProvider) {
            $stateProvider
                .state('root.files.add', {
                    url: '/add',
                    data: {
                        pageTitle: 'FILES.ADD_FILE.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<add-files-component/>',
                        },
                    },
                    bodyClass: 'page--files',
                });
            $translatePartialLoaderProvider.addPart('/js/files');
        })
        .component('addFilesComponent', {
            templateUrl: '/js/files/add-files/add-files.html',
            controller: AddFilesCtrl,
        });

})
(angular.module('rocket.components'));
